import { PropsWithChildren } from 'react';
import InputWithError from '../InputWithError/InputWithError';
import InputWithTitle from '../InputWithTitle/InputWithTitle';

interface FieldInfoWithTitleProps {
  title: string;
  errorText?: string;
  hasError: boolean;
  hidden?: boolean;
}

export const FieldInfo = ({
  title,
  children,
  errorText,
  hasError,
  hidden,
}: PropsWithChildren<FieldInfoWithTitleProps>) => {
  return (
    <InputWithTitle title={title} hidden={hidden}>
      <InputWithError errorText={errorText} hasError={hasError}>
        {children}
      </InputWithError>
    </InputWithTitle>
  );
};
